export default function SkeletonLetters() {
    return (
        <div className="w-[48%] bg-white border rounded-lg p-6 shadow-sm animate-pulse">

            <div className="flex justify-center mb-4">
                <div className="h-14 w-32 bg-gray-300 rounded"></div>
            </div>

            <div className="h-5 bg-gray-300 rounded mb-3"></div>

            <div className="space-y-2">
                <div className="h-3 bg-gray-200 rounded"></div>
                <div className="h-3 bg-gray-200 rounded"></div>
                <div className="h-3 bg-gray-200 rounded"></div>
            </div>

            <div className="mt-6">
                <div className="h-3 w-24 bg-gray-200 rounded mb-1"></div>
                <div className="h-3 w-20 bg-gray-200 rounded"></div>
            </div>

        </div>
    );
}